import React from 'react';
import ReactLoading from "react-loading";
export const Loading = (props) => {

    return (
        <div className={props.wrapperClass}>
            <ReactLoading
                type={props.type}
                color={props.color}
                height={props.height}
                width={props.width}
                className={props.className}
            />
        </div>
    );
}